import Button from '@mui/material/Button';
import { signInWithPopup } from 'firebase/auth';
import { auth, googleProvider } from '../config/firebase';
import { GoogleIcon } from './CustomIcons';

interface GoogleSignInButtonProps {
  label?: string;
  onSuccess?: () => void | Promise<void>;
  onError?: (error: Error) => void;
}

export default function GoogleSignInButton({
  label = 'Sign in with Google',
  onSuccess,
  onError,
}: GoogleSignInButtonProps) {
  const handleClick = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      await onSuccess?.();
    } catch (error) {
      onError?.(error as Error);
    }
  };

  return (
    <Button
      fullWidth
      variant="outlined"
      onClick={handleClick}
      startIcon={<GoogleIcon />}
    >
      {label}
    </Button>
  );
}
